import { ChainLabelEnum } from "features/bikeFleet/constant"
import { DataOperators, Entity } from "models"
import { isNotEmpty } from "utils"
import { BC_OPERATOR } from "./constants"

export const getBicycodeInfoFromPartner = (operators: DataOperators[]) => {
	const dataBicyCode = operators.find((operator) => operator.operator === BC_OPERATOR)
	return isNotEmpty(dataBicyCode) ? dataBicyCode : false
}

export const isStoreChainAuthorized = (chain) => {
	if (!chain || !isNotEmpty(chain)) return false
	return Object.entries(ChainLabelEnum)
		.map(([key, value]) => value)
		.includes(chain)
}

export const isAuthorizedAccessOrderLabel = (isBicyCodeOperator, currentStoreChain): boolean =>
	isBicyCodeOperator && isStoreChainAuthorized(currentStoreChain)
